import {
  defineCustomElementPnButton,
  defineCustomElementPnTable,
  defineCustomElementPnRadioButton,
  defineCustomElementPnCheckbox,
  defineCustomElementPnButtonDropdown,
  defineCustomElementPnSearchField,
  defineCustomElementPnToggleSwitch,
  defineCustomElementPnFieldset,
  defineCustomElementPnHeader,
  defineCustomElementPnTablist,
  defineCustomElementPnTab,
  defineCustomElementPnCard,
  defineCustomElementPnToast,
  defineCustomElementPnPagination,
  defineCustomElementPnFileUpload,
  defineCustomElementPnAccordion,
  defineCustomElementPnAccordionRow,
  defineCustomElementPnChoiceChip,
  defineCustomElementPnInput,
  defineCustomElementPnTag,
  defineCustomElementPnDatePicker,
  defineCustomElementPnModal,
  defineCustomElementPnTextLink,
} from '@postnord/web-components/components/index.js';

const defineSafely = (defineCustomElement: () => void): void => {
  try {
    defineCustomElement();
  } catch (error) {
    if (!(error instanceof DOMException) || error.name !== 'NotSupportedError') {
      throw error;
    }
  }
};

export const registerWebComponents = (): void => {
  defineSafely(defineCustomElementPnButton);
  defineSafely(defineCustomElementPnTable);
  defineSafely(defineCustomElementPnRadioButton);
  defineSafely(defineCustomElementPnCheckbox);
  defineSafely(defineCustomElementPnButtonDropdown);
  defineSafely(defineCustomElementPnSearchField);
  defineSafely(defineCustomElementPnToggleSwitch);
  defineSafely(defineCustomElementPnFieldset);
  defineSafely(defineCustomElementPnHeader);
  defineSafely(defineCustomElementPnTablist);
  defineSafely(defineCustomElementPnTab);
  defineSafely(defineCustomElementPnCard);
  defineSafely(defineCustomElementPnToast);
  defineSafely(defineCustomElementPnPagination);
  defineSafely(defineCustomElementPnFileUpload);
  defineSafely(defineCustomElementPnAccordion);
  defineSafely(defineCustomElementPnAccordionRow);
  defineSafely(defineCustomElementPnChoiceChip);
  defineSafely(defineCustomElementPnInput);
  defineSafely(defineCustomElementPnTag);
  defineSafely(defineCustomElementPnDatePicker);
  defineSafely(defineCustomElementPnModal);
  defineSafely(defineCustomElementPnTextLink);
};
